'use client';

import { useParams } from 'next/navigation';
import { PrivacyPolicyArabic } from '../privacy-policy-ar';
import { PrivacyPolicyEnglish } from '../privacy-policy-en';

export function PrivacyPolicyView() {
  const params = useParams();
  const { locale } = params;
  if (locale) {
    return <>{locale === 'ar' ? <PrivacyPolicyArabic /> : <PrivacyPolicyEnglish />}</>;
  }
}
